

export default function Services() {
  const services = [
    {
      title: 'Full-Service Bookkeeping',
      icon: 'ri-book-open-line',
      image: 'https://public.readdy.ai/ai/img_res/c0a1940b0d82561dc3d7555d595c57ad.jpg',
      points: [
        'Monthly transaction recording and reconciliations',
        'Invoicing, bill pay, and expense tracking',
        'QuickBooks Online setup and ongoing support'
      ]
    },
    {
      title: 'Financial Management & Reporting',
      icon: 'ri-bar-chart-box-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20financial%20charts%20and%20graphs%20printed%20on%20paper%20laid%20out%20on%20a%20clean%20desk%20with%20a%20pen%20and%20calculator%20nearby%20warm%20ambient%20lighting%20business%20reporting%20concept%20elegant%20minimalist%20style%20soft%20warm%20color%20palette&width=600&height=340&seq=svc-reporting-002&orientation=landscape',
      points: [
        'Monthly and quarterly financial statements',
        'Cash flow and budget monitoring',
        'Year-over-year variance analysis to support planning'
      ]
    },
    {
      title: 'Payroll & Advisory Support',
      icon: 'ri-hand-coin-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20scene%20with%20two%20people%20reviewing%20documents%20at%20a%20modern%20table%20warm%20lighting%20friendly%20advisory%20meeting%20concept%20clean%20minimalist%20office%20environment%20soft%20neutral%20warm%20tones&width=600&height=340&seq=svc-advisory-003&orientation=landscape',
      points: [
        'Payroll coordination and oversight',
        'Internal control and workflow recommendations',
        'On-call guidance for day-to-day financial questions'
      ]
    }
  ];

  const specialties = [
    { title: 'Real estate accounting', icon: 'ri-building-2-line' },
    { title: 'Insurance agency bookkeeping', icon: 'ri-shield-check-line' },
    { title: 'Churches and nonprofits using MIP Fund Accounting and Realm/ACS', icon: 'ri-community-line' }
  ];

  return (
    <section id="services" className="py-24 bg-warm-50 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#612c42]/3 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center mb-16">
          <span className="inline-block text-[#059669] text-sm font-semibold tracking-widest uppercase mb-4">What We Offer</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900" style={{ fontFamily: "'EB Garamond', 'Times New Roman', serif" }}>
            Services Tailored to Your Business
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-100 hover:border-[#612c42]/20 relative overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#612c42] to-[#c47a3a] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
              <div className="w-full h-[180px] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8">
                <div className="w-14 h-14 flex items-center justify-center bg-[#612c42]/8 rounded-lg mb-6 group-hover:bg-[#612c42] transition-colors duration-500 -mt-12 relative z-10 border-4 border-white shadow-md">
                  <i className={`${service.icon} text-2xl text-[#612c42] group-hover:text-white transition-colors duration-500`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-5" style={{ fontFamily: "'EB Garamond', serif" }}>
                  {service.title}
                </h3>
                <ul className="space-y-3">
                  {service.points.map((point, idx) => (
                    <li key={idx} className="flex items-start">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-arrow-right-s-line text-base text-[#059669]"></i>
                      </div>
                      <span className="ml-2 text-sm text-gray-600 leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#612c42] to-[#4a1f31] rounded-lg max-w-5xl mx-auto relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#c47a3a]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
          <div className="grid md:grid-cols-5 items-stretch">
            <div className="md:col-span-2 h-full">
              <div className="w-full h-full min-h-[240px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20beautiful%20suburban%20neighborhood%20with%20houses%20and%20green%20trees%20representing%20real%20estate%20and%20community%20warm%20golden%20hour%20lighting%20professional%20photography%20soft%20warm%20tones%20elegant%20composition&width=600&height=400&seq=svc-specialty-004&orientation=landscape"
                  alt="Specialized industries we serve"
                  className="w-full h-full object-cover object-top rounded-t-lg md:rounded-l-lg md:rounded-tr-none"
                />
              </div>
            </div>
            <div className="md:col-span-3 p-10 relative">
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: "'EB Garamond', serif" }}>
                  Specialized Industries
                </h3>
                <p className="text-sm text-white/70">Deep expertise in niche sectors</p>
              </div>
              <div className="space-y-4">
                {specialties.map((specialty, index) => (
                  <div
                    key={index}
                    className="flex items-start space-x-3 bg-white/10 backdrop-blur-sm p-5 rounded-lg border border-white/10 hover:bg-white/15 transition-colors cursor-default"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-[#059669]/30 rounded-lg flex-shrink-0">
                      <i className={`${specialty.icon} text-lg text-[#6ee7b7]`}></i>
                    </div>
                    <span className="text-base text-white/90 leading-relaxed">{specialty.title}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
